/*!
 * Erwin Müller Page Builder v1.0.0
 * Copyright (c) 2011-##current-year## Erwin Müller Versandhaus GmbH
 */
var PageBuilder = (function() {
  
  /**
   * Public scope
   * 
   * Public Scope des Modules das alle nach außen verfügbaren Variablen & Methoden bereit stellt. 
   * 
   * @since     1.0.0
   * @access    public
   */
  var _self = window.PageBuilder = {
    /**
     * Page Builder Version. 
     * 
     * Beinhaltet die aktuelle Version der Anwendung. 
     * 
     * @since     1.0.0
     * @access    private
     */
    version: '1.0.0',
  }
  
  return _self;
})();

